import { DateTime } from 'luxon';
import { DateRange as DateRangeBase } from 'components/DateRange';
import cn from 'classnames';
import { FormControl, FormControlBaseProps } from '../FormControl';
import { Button } from '../../Button';

import styles from './DateRange.module.scss';

export function DateRange({ className, ...props }: FormControlBaseProps) {
  return (
    <FormControl<{ From: number | string; To: number | string }>
      {...props}
      noFloat
      className={cn(styles.dateRange, className)}
    >
      {({ value, onChange, readOnly }) => {
        if (!value.From && !value.To) {
          throw new Error(
            'The From and To values are not set. Specify them in the default form data.'
          );
        }
        const from = DateTime.fromMillis(+value.From);
        const to = DateTime.fromMillis(+value.To);
        return (
          <DateRangeBase
            from={from}
            to={to}
            onChange={(dates) => {
              onChange({
                From: dates.from.toMillis(),
                To: dates.to.toMillis()
              });
            }}
          >
            <Button variant="button" type="button" disabled={readOnly}>
              {from.toLocaleString(DateTime.DATE_SHORT)}&nbsp;-&nbsp;
              {to.toLocaleString(DateTime.DATE_SHORT)}
            </Button>
          </DateRangeBase>
        );
      }}
    </FormControl>
  );
}
